import { __extends } from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import PollDuperbrowseLink from './PollDuperbrowseLink';
var PollOverlay = /** @class */ (function (_super) {
    __extends(PollOverlay, _super);
    function PollOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PollOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, deviation = _a.deviation, isOwner = _a.isOwner, t = _a.t;
        var label = 'poll.thumb.overlay.vote';
        if (isOwner || (deviation.poll && deviation.poll.hasVoted)) {
            label = 'poll.thumb.overlay.viewResults';
        }
        return (React.createElement("div", { className: className },
            React.createElement(PollDuperbrowseLink, { deviation: deviation }, t(label))));
    };
    return PollOverlay;
}(React.Component));
export default withTranslation()(PollOverlay);
//# sourceMappingURL=PollOverlay.js.map